import { LoadingOutlined } from "@ant-design/icons"
import { Progress, Space, Typography } from "antd"
import React from "react"

const { Title } = Typography

export const loadingSpin = (size) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 9999,
      }}>
      <LoadingOutlined
        style={{
          fontSize: size,
          color: "#1677ff",
        }}
        spin
      />
    </div>
  )
}

export const loadingSpinWithBg = (size, text) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        position: "fixed",
        background: "rgba(255, 255, 255, 0.5)", // Set background with opacity
        top: 0,
        left: 0,
        zIndex: 9999,
      }}>
      <Space align="center" direction="vertical">
        <Title>{text}</Title>
        <LoadingOutlined
          style={{
            fontSize: size,
          }}
          spin
        />
      </Space>
    </div>
  )
}

export const progressBarLoading = (percent, currentItem, totalItems, text) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        position: "fixed",
        background: "rgba(255, 255, 255, 0.95)", // Set background with opacity
        top: 0,
        left: 0,
        zIndex: 9999,
      }}>
      <div
        style={{
          width: 500,
          textAlign: "center",
        }}>
        <Title>{text}</Title>
        <Progress percent={percent} format={() => `${currentItem}/${totalItems}`} />
      </div>
    </div>
  )
}
